import { useEffect } from 'react'
import { useRegisterSW } from 'virtual:pwa-register/react'

export function UpdatePrompt() {
  const {
    offlineReady: [offlineReady, setOfflineReady],
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW()

  useEffect(() => {
    if (!offlineReady) return

    const timer = window.setTimeout(() => setOfflineReady(false), 5_000)
    return () => window.clearTimeout(timer)
  }, [offlineReady, setOfflineReady])

  return (
    <>
      {offlineReady ? (
        <p className="pwa-notice" role="status" aria-live="polite">
          应用已可离线使用
        </p>
      ) : null}
      {needRefresh ? (
        <aside
          className="pwa-update-prompt"
          role="dialog"
          aria-modal="false"
          aria-labelledby="pwa-update-title"
        >
          <p id="pwa-update-title">新版本已准备好</p>
          <div className="pwa-update-actions">
            <button type="button" onClick={() => void updateServiceWorker(true)}>
              立即更新
            </button>
            <button type="button" onClick={() => setNeedRefresh(false)}>
              稍后
            </button>
          </div>
        </aside>
      ) : null}
    </>
  )
}
